import gql from 'graphql-tag';

export const UPDATE_EMPLOYMENT = gql`
  mutation (
    $id: ID!
    $from: DateTime!
    $to: DateTime
    $presentEmploymentIndicator: Boolean!
    $employmentMode: EmploymentMode!
    $employmentField: String!
    $organisationName: String!
    $position: String!
    $majorResponsibilities: String
    $supportingDocuments: [FileTypeInput!]
  ) {
    updateEmployment(
      id: $id
      input: {
        from: $from
        to: $to
        presentEmploymentIndicator: $presentEmploymentIndicator
        employmentMode: $employmentMode
        employmentField: $employmentField
        organisationName: $organisationName
        position: $position
        majorResponsibilities: $majorResponsibilities
        supportingDocuments: $supportingDocuments
      }
    ) {
      _id
    }
  }
`;
